export const FG_TRACKING_TITLE = "FG Tracking";

export const FG_TRACKING_TABS = [
  {
    value: "paymentPending",
    label: "Payment pending",
  },
  {
    value: "doPending",
    label: "DO pending",
  },
  {
    value: "doCreated",
    label: "DO created",
  },
  // {
  //   value: "exceptions",
  //   label: "Exceptions",
  // },
];

export const ORDER_TABLE_COLUMNS = [
  "",
  "Buyer order no.",
  "Seller name & order",
  "Expected dispatch date",
  "Buyer",
  "Ship to",
  "Total qty",
  "FG ready",
  "Payment",
  "FG ready by",
  "Ageing",
];

export const LINE_ITEM_COLUMNS = [
  "",
  "Material ID",
  "Order Qty",
  "FG Ready",
  "Expected FG",
  "Seller Update Awaited",
  "FG Due By",
  "Actions",
];

export const DO_PENDING_AND_DO_CREATED_LINEITEM_COLUMNS = [
  "Material ID",
  "Order Qty",
  "FG Qty",
  "DO Qty",
  "Seller Order Ref# · OL Ref# · Seller SKU · Description",
  "Rate (Excl. Tax)",
  "FG Ready By",
  "Actions",
];

export const PAYMENT_PENDING_LINEITEM_COLUMNS = [
  "Material ID",
  "Order Qty",
  "FG Qty",
  "Seller Order Ref# · OL Ref# · Seller SKU · Description",
  "Rate (Excl. Tax)",
  "FG Ready By",
];

export const FG_TRACKING_LABELS = {
  selectAll: "Select all",
  fgReadyTag: "FG ready",
  expectedFgTag: "Expected FG",
  dueDateLabel: "Due date *",
  dueDatePlaceholder: "dd-mm-yyyy",
  cancelCta: "Cancel",
  submitCta: "Submit",
  updateFgCta: "Update FG",
  historyCta: "History",
  bulkUpdateCopy: "Bulk update FG for all eligible line items",
  partialPayment: "Partial",
  pendingPayment: "Pending",
  noLineItems: "No line items found for this order.",
  infoMessageFgReadyPrefix: "Will mark",
  infoMessageFgReadyMiddle: "line items as FG ready in full qty",
  infoMessageExpectedPrefix: "Will mark",
  infoMessageExpectedMiddle: "line items as Expected FG in full qty",
  infoMessageExpectedDatePrefix: "due",
};

export const FG_BULK_ACTION_MODE = {
  FG_READY: "fgReady",
  EXPECTED_FG: "expectedFg",
};

export const FG_LINE_ITEM_ENDPOINTS = {
  fetchUpdates: "joms/api/internal/v1/finished-goods/fetch-fg-lineitem-updates",
  update: "joms/api/internal/v1/finished-goods/update",
};

const TAB_CODE_BY_VALUE = {
  dueDatePending: "fgpend",
  paymentPending: "pypend",
  doPending: "dopend",
  doCreated: "docr",
};

const getFgReadyByDaysDelta = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  const match = value.match(/-?\d+/);
  if (!match) {
    return null;
  }

  const parsed = Number(match[0]);
  return Number.isNaN(parsed) ? null : parsed;
};

const isFgReadyByOverdue = (order) => {
  const daysDelta = getFgReadyByDaysDelta(order.fgReadyByDelta);
  if (daysDelta !== null) {
    return daysDelta < 0;
  }

  return false;
};

export const getOrdersForTab = (orders, tabValue) => {
  if (tabValue === "allOrders") {
    return orders;
  }

  if (tabValue === "dueDatePending") {
    // Include orders that are overdue by FG ready date OR that have exceptions
    return orders.filter(
      (order) => isFgReadyByOverdue(order) || Boolean(order.hasException),
    );
  }

  if (tabValue === "exceptions") {
    return orders.filter((order) => order.hasException);
  }

  const tabCode = TAB_CODE_BY_VALUE[tabValue];
  return orders.filter((order) => (order.tabs || []).includes(tabCode));
};

export const DELIVERY_TYPE = {
  all: "ALL",
  jots: "JOTS",
  sellerDelivery: "Seller Delivery",
  buyerPickup: "Self pickup",
};

export const ORDER_TYPES = [
  "ALL",
  "Distributed",
  "Plant Supply",
  "Private Brands",
];

export const orderTypesPayloadMap = {
  ALL: "",
  Distributed: "DISTRIBUTED",
  "Plant Supply": "PLANT SUPPLY",
  "Private Brands": "PRIVATE BRAND",
};

export const FG_READINESS = ["FG readiness", "Order confirmation"];

export const fgReadinessPayloadMap = {
  "FG readiness": "FG_READY",
  "Order confirmation": "ORD_CNF",
};

export const inputFieldSx = {
  "& .MuiOutlinedInput-root": {
    height: 40,
  },
  "& .MuiInputLabel-root": {
    top: "0px",
  },
  "& .MuiInputLabel-shrink": {
    top: "0px",
  },
};

export const SELECT_ALL_ELIGIBILITY_MESSAGE =
  "Can't bulk update, some selected lines are already updated";

export const remarkList = [
  "Seller Delay - Allocation Issue / High Seller Load",
  "Seller Delay - Plant MOQ issue",
  "Seller Delay - Seller Breakdowns and RM Shortages",
  "Seller Delay - Campaign Delays",
  "⁠Seller Delay - Production Quality Issues",
  "Customer Requested Change",
  "Multi-Seller Order: Balance Quantity Not Ready",
  "Material Diverted to Other Requirement",
  "Logistics Not Available",
  "Other Reasons",
];
